export function buildWorkspaceSnippet(workspaceId: string): string {
  return `workspace {\n    id = "${workspaceId}"\n}`;
}

export function buildLoginSnippet(workspaceId: string): string {
  return [
    `terrabuild login --workspace ${workspaceId}`,
    "                 --token <your-token>",
    "                 --masterkey <your-masterkey>",
  ].join(" \\\n");
}
